import React, { useRef } from "react";
import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import Container from "Components/Container/Container";

// swiper
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
const ProductSlider = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <section className="normal-section mb-primary mt-primary lg:mt-52">
      <Container>
        <div className="flex items-center gap-x-16 mb-10 justify-center">
          <button
            ref={prevRef}
            className="slider-arrow z-[100] bg-light flex items-center justify-center bg-black text-2xl text-black rounded-full p-1"
          >
            <ArrowLeft />
          </button>
          <h4 className="text-xl sm:text-2xl lg:text-3xl uppercase text-center font-bold text-white ">
            Other products of similar category
          </h4>

          <button
            ref={nextRef}
            className="slider-arrow z-[100] rounded-full flex items-center justify-center bg-black text-2xl text-black bg-light p-1"
          >
            <ArrowRight />
          </button>
        </div>
      </Container>
      <div className="flex items-center gap-x-4 px-6">
        <Swiper
          className=" w-full"
          spaceBetween={20}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          }}
          modules={[Autoplay, Navigation]}
          speed={1000}
        >
          {data?.map(({ name, image, slug }, index) => (
            <SwiperSlide key={index}>
              <Link
                to={`/detailed-product/${slug}`}
                className="flex-1 group  block"
              >
                <div className="overflow-hidden ">
                  <img
                    src={image}
                    alt=""
                    className="object-contain max-h-[200px] min-h-[200px] w-full group-hover:scale-[1.05] transition ease-in duration-300 "
                  />
                </div>
                <p className="text-white mt-2">{name}</p>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProductSlider;
